<template>
  <div>
    <div
      class="flex flex-col cursor-pointer gap-2.5 md:gap-[15px] p-4 md:p-6"
      @click="toggleDropdown()"
    >
      <div class="flex justify-between items-center">
        <h5 v-i18n="landingPage" :class="isVisible && 'text-primary-purple-700'">
          {{ options.question }}
        </h5>
        <span>
          <icon
            :key="`icon-render${isVisible}`"
            class="icon opacity-50 lg:opacity-100 mr-1 md:mr-2 cursor-pointer"
            :color="isVisible ? 'primary-purple-700' : 'primary-gray-500'"
            :icon="isVisible ? 'chevron-up' : 'chevron-bottom'"
            height="8"
            width="15"
          />
        </span>
      </div>
      <div v-if="isVisible">
        <p2 v-i18n="landingPage">{{ options.answer }}</p2>
      </div>
    </div>
  </div>
</template>

<script>
import icon from '@components/icons/icon.vue'

export default {
  name: 'Faqs',
  components: {
    icon,
  },
  props: {
    options: {
      type: [Array, Object],
      default: () => [],
    },
  },
  data: function () {
    return {
      landingPage: 'landingPage',
      isVisible: false,
    }
  },
  methods: {
    toggleDropdown() {
      this.isVisible = !this.isVisible
    },
  },
}
</script>
